import {Flex, Radio, RadioGroup, Stack, Text} from '@chakra-ui/react'
import {randomElementIndexInArray} from '@utils'
import {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'

const RadioPhrase = ({
  setDataReply,
  setIsResult,
}: {
  setDataReply: any
  setIsResult: any
}) => {
  const {currentQuestion, isDisableReply} = useSelector(
    (state: any) => state.revise,
  )
  const [radioValue, setRadioValue] = useState<any>('')
  const [choices, setChoices] = useState<any>([])

  useEffect(() => {
    if (!currentQuestion) {
      return
    }
    const updateChoices = randomElementIndexInArray(
      currentQuestion?.data.question?.choices,
    )
    setChoices(updateChoices)
  }, [currentQuestion])

  const handleChangeValue = (value: any) => {
    setRadioValue(value)
    choices.forEach((item: any) => {
      if (item.text === value) {
        setIsResult(item.is_true_answer)
      }
    })
    const textDemoSplit = currentQuestion?.data.question.fill_answer.split(' ')
    const newTextDemoSplit = textDemoSplit.map((item: any) => {
      return {
        text: item,
        type: item.includes('_') ? 'empty' : null,
      }
    })
    textDemoSplit.forEach((item: any, index: any) => {
      if (item.includes('_')) {
        newTextDemoSplit[index] = {
          text: value,
          type: 'option',
        }
        setDataReply(newTextDemoSplit)
      }
    })
  }

  return (
    <Flex w={'90%'} ml={'auto'} mb={'16px'} flexDirection={'column'}>
      <Text
        fontSize={'16px'}
        p={'16px'}
        bg={isDisableReply ? '#F5F5F5' : '#E6F7FF'}
        color={isDisableReply ? 'rgba(0, 0, 0, 0.25)' : '#0050B3'}
        borderRadius={'32px'}
        w={'fit-content'}
        ml={'auto'}
        fontWeight={500}>
        {currentQuestion?.data.question?.fill_answer
          .split(' ')
          .map((item: any, index: any) => (
            <Text
              key={index}
              as={'span'}
              fontFamily={item.includes('_') ? 'Lexend' : 'unset'}>
              {`${item} `}
            </Text>
          ))}
      </Text>
      <Flex mt={'16px'} gap={'16px'}>
        <RadioGroup
          isDisabled={isDisableReply}
          pl={'15px'}
          onChange={handleChangeValue}
          value={radioValue}>
          <Stack direction="column" spacing={'16px'}>
            {choices?.map((item: any, index: any) => {
              return (
                <Radio key={index} value={item.text}>
                  {item.text}
                </Radio>
              )
            })}
          </Stack>
        </RadioGroup>
      </Flex>
    </Flex>
  )
}
export default RadioPhrase
